import { render, staticRenderFns } from "./FAQAdmin.vue?vue&type=template&id=1134b527&scoped=true&"
import script from "./FAQAdmin.vue?vue&type=script&lang=js&"
export * from "./FAQAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FAQAdmin.vue?vue&type=style&index=0&id=1134b527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134b527",
  null
  
)

export default component.exports